import { switchClasses, Theme } from '@mui/material';

export const switchOverrides = {
  root: {
    width: 40,
    height: 24,

    padding: 0,
    marginLeft: 10,
    marginRight: 10,
  },

  track: {
    borderRadius: 12,
    opacity: 0.3,

    [`&.${switchClasses.disabled}`]: {
      opacity: 0.1,
    },
  },

  thumb: {
    width: 16,
    height: 16,
    boxShadow: 'none',
  },

  switchBase: ({ theme }: { theme: Theme }) => ({
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',

    [`&.${switchClasses.checked}`]: {
      color: theme.palette.common.white,
      transform: 'translateX(16px)',

      [`&+.${switchClasses.track}`]: {
        opacity: 1,
      },

      [`&.${switchClasses.disabled}`]: {
        color: theme.palette.grey[500],
      },
    },

    [`&.${switchClasses.disabled}`]: {
      color: theme.palette.grey[500],
      opacity: 0.5,

      [`& + .${switchClasses.track}`]: {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.1,
      },
    },
  }),
};
